function initGetInspired() {
  const getInspired = document.querySelector('[data-get-inspired]');
  const getInspiredScroll = document.querySelector('[data-get-inspired-scroll]');
  const getInspiredBlocks = document.querySelectorAll('[data-get-inspired-block]');
  const breakpoint = window.matchMedia('(min-width: 750px)');
  let scrollMeInt = null;
  let lastX = 0;

  if (!getInspiredBlocks) { return; }

  function desktopParallax() {
    const sectionRect = getInspired.getBoundingClientRect();

    if (sectionRect.y > window.innerHeight) { return; }

    const scrollPercentage = (sectionRect.y * -1 + window.innerHeight) / (sectionRect.height + window.innerHeight);

    for (let i = 0; i < getInspiredBlocks.length; i++) {
      const block = getInspiredBlocks[i];
      const translateValue = -50 + (scrollPercentage * 150 * block.dataset.getInspiredBlockParallaxDesktop);
      block.style.transform = `translate3d(0, ${translateValue}px, 0)`;
    }
  }

  function mobileParallax() {
    const scrollWidth = 1000 - window.innerWidth;
    const scrollPercentage = getInspiredScroll.scrollLeft / scrollWidth;

    for (let i = 0; i < getInspiredBlocks.length; i++) {
      const block = getInspiredBlocks[i];
      const translateValue = scrollPercentage * (100 / block.dataset.getInspiredBlockParallaxDesktop);
      block.style.transform = `translate3d(${translateValue}px, 0, 0)`;
    }
  }

  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        getInspiredScroll.addEventListener('scroll', mobileParallax);
      } else {
        getInspiredScroll.removeEventListener('scroll', mobileParallax);
      }
    });
  }, {
    threshold: 0.1,
  });

  const blockObserverDesktop = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
      }
    });
  }, {
    threshold: 0.5,
  });

  const blockObserverMobile = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
      }
    });
  }, {
    root: getInspiredScroll,
    threshold: 0.5,
  });

  function setupScrollMeInterval() {
    let yTo = 0;
    let prevScrollLeft = 0;
    scrollMeInt = setInterval(() => {
      yTo += 1.5;
      getInspiredScroll.scrollLeft = yTo;
      if (prevScrollLeft === getInspiredScroll.scrollLeft) {
        yTo = 0;
      }
      prevScrollLeft = getInspiredScroll.scrollLeft;
    }, 50);
  }

  function killScrollMeInterval() {
    clearInterval(scrollMeInt);
  }

  getInspiredScroll.addEventListener('touchstart', (event) => {
    lastX = event.touches ? event.touches[0].pageX : event.pageX;
  });

  getInspiredScroll.addEventListener('touchmove', (event) => {
    const currentX = event.touches ? event.touches[0].pageX : event.pageX;
    if (Math.abs(currentX - lastX) < 30) { return; }
    killScrollMeInterval();
  });

  getInspiredScroll.addEventListener('wheel', (event) => {
    if (event.deltaX > event.deltaY) {
      killScrollMeInterval();
    }
  });

  let ticking = false;
  function handleDesktopScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        desktopParallax();
        ticking = false;
      });
      ticking = true;
    }
  }

  function breakpointSwitch() {
    if (breakpoint.matches === true) {
      resetBlocks();
      killScrollMeInterval();
      window.addEventListener('scroll', handleDesktopScroll);
      sectionObserver.unobserve(getInspiredScroll);
      getInspiredBlocks.forEach(block => {
        blockObserverDesktop.observe(block);
        blockObserverMobile.unobserve(block);
      });
    } else {
      resetBlocks();
      setupScrollMeInterval();
      window.removeEventListener('scroll', handleDesktopScroll);
      sectionObserver.observe(getInspiredScroll);
      getInspiredBlocks.forEach(block => {
        blockObserverDesktop.unobserve(block);
        blockObserverMobile.observe(block);
      });
    }
  }

  function resetBlocks() {
    getInspiredBlocks.forEach(block => block.removeAttribute('style'));
  }

  breakpoint.addListener(breakpointSwitch);

  breakpointSwitch();
}

document.addEventListener('DOMContentLoaded', () => {
  initGetInspired();
});

document.addEventListener('shopify:section:load', () => {
  initGetInspired();
});
